import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ExportIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M11.08 14.3V6.08L7.48 9.7L6.38 8.62L12 3L17.62 8.62L16.52 9.7L12.92 6.08V14.3H11.08ZM5.24 13.86H7.08V17.16H16.92V13.86H18.76V19H5.24V13.86Z" />
    </SvgIcon>
  );
});
